/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Asset golden row for Integrations inventory list (REQ-INV-06)
 * @export
 * @interface AssetInventoryListItemDto
 */
export interface AssetInventoryListItemDto {
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryListItemDto
     */
    assetGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryListItemDto
     */
    assetClass?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryListItemDto
     */
    hostname?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryListItemDto
     */
    fqdn?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryListItemDto
     */
    hardwareUuid?: string;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryListItemDto
     */
    materializedOpenVulnCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryListItemDto
     */
    materializedOpenWeaknessCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryListItemDto
     */
    openComplianceFailCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryListItemDto
     */
    sourceCount?: number;
}

/**
 * Check if a given object implements the AssetInventoryListItemDto interface.
 */
export function instanceOfAssetInventoryListItemDto(value: object): value is AssetInventoryListItemDto {
    return true;
}

export function AssetInventoryListItemDtoFromJSON(json: any): AssetInventoryListItemDto {
    return AssetInventoryListItemDtoFromJSONTyped(json, false);
}

export function AssetInventoryListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetInventoryListItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetGoldenId': json['assetGoldenId'] == null ? undefined : json['assetGoldenId'],
        'assetClass': json['assetClass'] == null ? undefined : json['assetClass'],
        'hostname': json['hostname'] == null ? undefined : json['hostname'],
        'fqdn': json['fqdn'] == null ? undefined : json['fqdn'],
        'hardwareUuid': json['hardwareUuid'] == null ? undefined : json['hardwareUuid'],
        'materializedOpenVulnCount': json['materializedOpenVulnCount'] == null ? undefined : json['materializedOpenVulnCount'],
        'materializedOpenWeaknessCount': json['materializedOpenWeaknessCount'] == null ? undefined : json['materializedOpenWeaknessCount'],
        'openComplianceFailCount': json['openComplianceFailCount'] == null ? undefined : json['openComplianceFailCount'],
        'sourceCount': json['sourceCount'] == null ? undefined : json['sourceCount'],
    };
}

export function AssetInventoryListItemDtoToJSON(json: any): AssetInventoryListItemDto {
    return AssetInventoryListItemDtoToJSONTyped(json, false);
}

export function AssetInventoryListItemDtoToJSONTyped(value?: AssetInventoryListItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetGoldenId': value['assetGoldenId'],
        'assetClass': value['assetClass'],
        'hostname': value['hostname'],
        'fqdn': value['fqdn'],
        'hardwareUuid': value['hardwareUuid'],
        'materializedOpenVulnCount': value['materializedOpenVulnCount'],
        'materializedOpenWeaknessCount': value['materializedOpenWeaknessCount'],
        'openComplianceFailCount': value['openComplianceFailCount'],
        'sourceCount': value['sourceCount'],
    };
}

